import type { MuiPage } from '@mui/docs/MuiPage';

const datePickersApiPages: MuiPage[] = [
  {
    pathname: '/x/api/date-pickers/date-calendar',
    title: 'DateCalendar',
  },
  {
    pathname: '/x/api/date-pickers/date-field',
    title: 'DateField',
  },
  {
    pathname: '/x/api/date-pickers/date-picker',
    title: 'DatePicker',
  },
  {
    pathname: '/x/api/date-pickers/date-picker-toolbar',
    title: 'DatePickerToolbar',
  },
  {
    pathname: '/x/api/date-pickers/date-range-calendar',
    title: 'DateRangeCalendar',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/date-range-picker',
    title: 'DateRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/date-range-picker-day',
    title: 'DateRangePickerDay',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/date-range-picker-day-2',
    title: 'DateRangePickerDay2',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/date-range-picker-toolbar',
    title: 'DateRangePickerToolbar',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/date-time-field',
    title: 'DateTimeField',
  },
  {
    pathname: '/x/api/date-pickers/date-time-picker',
    title: 'DateTimePicker',
  },
  {
    pathname: '/x/api/date-pickers/date-time-picker-tabs',
    title: 'DateTimePickerTabs',
  },
  {
    pathname: '/x/api/date-pickers/date-time-picker-toolbar',
    title: 'DateTimePickerToolbar',
  },
  {
    pathname: '/x/api/date-pickers/date-time-range-picker',
    title: 'DateTimeRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/date-time-range-picker-tabs',
    title: 'DateTimeRangePickerTabs',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/date-time-range-picker-toolbar',
    title: 'DateTimeRangePickerToolbar',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/day-calendar-skeleton',
    title: 'DayCalendarSkeleton',
  },
  {
    pathname: '/x/api/date-pickers/desktop-date-picker',
    title: 'DesktopDatePicker',
  },
  {
    pathname: '/x/api/date-pickers/desktop-date-range-picker',
    title: 'DesktopDateRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/desktop-date-time-picker',
    title: 'DesktopDateTimePicker',
  },
  {
    pathname: '/x/api/date-pickers/desktop-date-time-range-picker',
    title: 'DesktopDateTimeRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/desktop-time-picker',
    title: 'DesktopTimePicker',
  },
  {
    pathname: '/x/api/date-pickers/desktop-time-range-picker',
    title: 'DesktopTimeRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/digital-clock',
    title: 'DigitalClock',
  },
  {
    pathname: '/x/api/date-pickers/localization-provider',
    title: 'LocalizationProvider',
  },
  {
    pathname: '/x/api/date-pickers/mobile-date-picker',
    title: 'MobileDatePicker',
  },
  {
    pathname: '/x/api/date-pickers/mobile-date-range-picker',
    title: 'MobileDateRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/mobile-date-time-picker',
    title: 'MobileDateTimePicker',
  },
  {
    pathname: '/x/api/date-pickers/mobile-date-time-range-picker',
    title: 'MobileDateTimeRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/mobile-time-picker',
    title: 'MobileTimePicker',
  },
  {
    pathname: '/x/api/date-pickers/mobile-time-range-picker',
    title: 'MobileTimeRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/month-calendar',
    title: 'MonthCalendar',
  },
  {
    pathname: '/x/api/date-pickers/multi-input-date-range-field',
    title: 'MultiInputDateRangeField',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/multi-input-date-time-range-field',
    title: 'MultiInputDateTimeRangeField',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/multi-input-time-range-field',
    title: 'MultiInputTimeRangeField',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/multi-section-digital-clock',
    title: 'MultiSectionDigitalClock',
  },
  {
    pathname: '/x/api/date-pickers/picker-day-2',
    title: 'PickerDay2',
  },
  {
    pathname: '/x/api/date-pickers/pickers-action-bar',
    title: 'PickersActionBar',
  },
  {
    pathname: '/x/api/date-pickers/pickers-calendar-header',
    title: 'PickersCalendarHeader',
  },
  {
    pathname: '/x/api/date-pickers/pickers-day',
    title: 'PickersDay',
  },
  {
    pathname: '/x/api/date-pickers/pickers-layout',
    title: 'PickersLayout',
  },
  {
    pathname: '/x/api/date-pickers/pickers-range-calendar-header',
    title: 'PickersRangeCalendarHeader',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/pickers-section-list',
    title: 'PickersSectionList',
  },
  {
    pathname: '/x/api/date-pickers/pickers-shortcuts',
    title: 'PickersShortcuts',
  },
  {
    pathname: '/x/api/date-pickers/pickers-text-field',
    title: 'PickersTextField',
  },
  {
    pathname: '/x/api/date-pickers/single-input-date-range-field',
    title: 'SingleInputDateRangeField',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/single-input-date-time-range-field',
    title: 'SingleInputDateTimeRangeField',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/single-input-time-range-field',
    title: 'SingleInputTimeRangeField',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/static-date-picker',
    title: 'StaticDatePicker',
  },
  {
    pathname: '/x/api/date-pickers/static-date-range-picker',
    title: 'StaticDateRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/static-date-time-picker',
    title: 'StaticDateTimePicker',
  },
  {
    pathname: '/x/api/date-pickers/static-time-picker',
    title: 'StaticTimePicker',
  },
  {
    pathname: '/x/api/date-pickers/time-clock',
    title: 'TimeClock',
  },
  {
    pathname: '/x/api/date-pickers/time-field',
    title: 'TimeField',
  },
  {
    pathname: '/x/api/date-pickers/time-picker',
    title: 'TimePicker',
  },
  {
    pathname: '/x/api/date-pickers/time-picker-toolbar',
    title: 'TimePickerToolbar',
  },
  {
    pathname: '/x/api/date-pickers/time-range-picker',
    title: 'TimeRangePicker',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/time-range-picker-tabs',
    title: 'TimeRangePickerTabs',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/time-range-picker-toolbar',
    title: 'TimeRangePickerToolbar',
    plan: 'pro',
  },
  {
    pathname: '/x/api/date-pickers/year-calendar',
    title: 'YearCalendar',
  },
];
export default datePickersApiPages;
